var map = {
	"./basketball.webp": 1646,
	"./bti-img.webp": 1647,
	"./bti-title-en.webp": 1648,
	"./cup.webp": 1649,
	"./football.webp": 1650,
	"./im-img.webp": 1651,
	"./im-title-en.webp": 1652,
	"./sb-img.webp": 1653,
	"./sb-title-cn.webp": 1654,
	"./sb-title-en.webp": 1655,
	"./sbo-img.webp": 1656,
	"./sbo-title-cn.webp": 1657,
	"./sbo-title-en.webp": 1658,
	"./sport-bg.webp": 1659,
	"./sport-ctg.webp": 1660,
	"./title-cn.webp": 1661,
	"./title-en.webp": 1662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 787;